import { render, staticRenderFns } from "./InfrastructureDetailsModal.vue?vue&type=template&id=6de73484&"
import script from "./InfrastructureDetailsModal.vue?vue&type=script&lang=js&"
export * from "./InfrastructureDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./InfrastructureDetailsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports